<template lang="html">
<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
              <!--SID0013 Body Part-->
							<template>
								<el-container class="SID0013__Article0013">
									<div id="SID0013__Container" v-loading="loading">
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                          <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧) </el-breadcrumb-item>
                          <el-breadcrumb-item :to="{ path: '0011' }">検索条件一覧</el-breadcrumb-item>
                          <el-breadcrumb-item :to="{ path: '0012' }">検索条件登録</el-breadcrumb-item>
                          <el-breadcrumb-item>お試し検索結果</el-breadcrumb-item>
                        </el-breadcrumb>
                      <div >
                      <span class="span0013">お試し検索結果 ({{this.TotalCount}}件)</span>
                      </div>
                    <div id="aricleNews" class="Article0013" v-if="news_article_flag && user_group_news_article_flag">
                          <NewsArticle />
                        </div>
                        <div id="aricleNews" class="Article0013" v-if="getMagazine_Article_Flag && getUserGroup_Magazine_Article_Flag">
                          <magazineArticle />
                        </div>
                        <div id="aricleNews" class="Article0013" v-if="web_news_article_flag && user_group_web_news_article_flag">
                          <webArticle />
                        </div>
                  </div>
								</el-container>
							</template>
              <!--SID0013 Body Part End-->
						</pane>
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>
			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>

<script lang="js">
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import NewsArticle from "../top_page/newsArticle.vue";
import webArticle from "../top_page/webArticle.vue";
import magazineArticle from "../top_page/magazineArticle.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
  export default  {
    name: 'SID0013',
    components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
    Pane,
    NewsArticle,
    webArticle,
    magazineArticle
	},
    props: [],
    mounted () {
      var font_size_flag = this.getDefault_Font_Size
          if(font_size_flag == 0)
        {
          this.isActive = true
          this.isMedActive = false
          this.isBigActive = false
        }
        else if(font_size_flag == 1)
        {
          this.isActive = false
          this.isMedActive = true
          this.isBigActive = false
        }
        else
        {
          this.isActive = false
          this.isMedActive = false
          this.isBigActive = true
        }
        //get the news_article_flag from the session
        this.news_article_flag = this.getNews_Article_Flag
        //get the web_news_article_flag from the session
        this.web_news_article_flag = this.getWeb_News_Article_Flag
        //get the user_group_news_article_flag from the session
        this.user_group_news_article_flag = this.getUserGroup_News_Article_Flag
        //get the user_group_web_news_article_flag from the session
        this.user_group_web_news_article_flag = this.getUserGroup_Web_News_Article_Flag

       var credentials = JSON.parse(this.$session.get('data'));
       this.loading=true;
        this.$store.dispatch('communication0013/getNewsArticles',credentials).then(() => {
          this.TotalCount+=this.news_article_flag && this.user_group_news_article_flag?this.getNewsCount:0
          this.TotalCount+=this.web_news_article_flag && this.user_group_web_news_article_flag?this.getWebCount:0
          this.TotalCount+=this.getMagazine_Article_Flag && this.getUserGroup_Magazine_Article_Flag?this.getMagazineCount:0
          this.loading=false;
        }).catch(() => {
            this.loading = false;
          })
    },
    data () {
      return {
          activeName: 'first',
          loading:false,
           isActive: false,
      isMedActive: false,
      isBigActive: false,
      news_article_flag: false,
      web_news_article_flag: false,
      user_group_news_article_flag: false,
      user_group_web_news_article_flag: false,
        TotalCount:0,
      }    
    },
    methods: {
    
    },
    

    computed: {
      ...mapGetters("situation0013", [
      "getresultvalue",
      "getWebArticles",
      "getMagazineArticles",
      "getNewsArticles",
      "getTotalCount",
      "getWebCount",
      "getNewsCount",
      "getMagazineCount"
    ]),
    ...mapGetters("situation0001", [
      "getNews_Article_Flag",
      "getDefault_Font_Size",
      "getWeb_News_Article_Flag",
      "getMagazine_Article_Flag",
      "getUserGroup_News_Article_Flag",
      "getUserGroup_Web_News_Article_Flag",
      "getUserGroup_Magazine_Article_Flag"
    ]) 
    },
    created() {
      //For the screen Title
      document.title = "記事閲覧";
    },
}
</script>

<style scoped>
@import "0013.css";
</style>